const DOCS_BASE_URL = "https://docs.replo.app";

/**
 * Links into the public docs site (apps/docs). Paths must be real pages, not
 * docs.json redirects, and anchors are Mintlify's slugified headings, so
 * renaming a docs page or heading means updating it here.
 */
export const DOCS = {
  home: DOCS_BASE_URL,
  billing: `${DOCS_BASE_URL}/billing`,
  sitesVsThemes: `${DOCS_BASE_URL}/getting-started/sites-vs-themes`,
  migrateFromReploShops: `${DOCS_BASE_URL}/migrate-from-replo-shops`,
  apiReference: `${DOCS_BASE_URL}/api-reference/introduction`,
  git: {
    overview: `${DOCS_BASE_URL}/git/overview`,
  },
  mcp: {
    connectOtherClients: `${DOCS_BASE_URL}/mcp/connect-with-other-ai-clients`,
    connectOpenClaw: `${DOCS_BASE_URL}/mcp/connect-with-other-ai-clients#connect-from-openclaw`,
  },
  languages: `${DOCS_BASE_URL}/features/languages`,
  cookieConsent: `${DOCS_BASE_URL}/features/cookie-consent`,
  scripts: {
    loadGoogleAnalyticsThroughGoogleTagManager: `${DOCS_BASE_URL}/features/scripts#load-google-analytics-through-google-tag-manager`,
  },
  integrations: {
    klaviyo: `${DOCS_BASE_URL}/integrations/klaviyo`,
  },
} as const;
